import type PopoutChildStore from './schema/PopoutChildStore';
import { PopoutChildState } from './schema/PopoutChildStore';
import { createStore } from 'owa-satcheljs';
import { POPOUT_V2_QUERY, POPOUT_V2_VALUE } from '../utils/constants';
import { getQueryStringParameter } from 'owa-querystring';

const childStoreData: PopoutChildStore = {
    state: PopoutChildState.NotStarted,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function getQueryStringParameter called at module scope is not allowed. This may cause unwanted side effects. */
    isPopoutV2: getQueryStringParameter(POPOUT_V2_QUERY) == POPOUT_V2_VALUE,
};

export const getStore: () => PopoutChildStore = createStore<PopoutChildStore>(
    'popoutChild',
    childStoreData
);
